export const baseURL = "https://casino.talentinco.com/";
export const adminBaseURL = "https://admin.talentinco.com/";
export const key = "LiRhuZZejJFrDZEHCtyLO0q2bDuIIhJL";